import React, { useState, useEffect } from 'react';
import { Paper, TableCell, Table, TableHead, TableRow, TableContainer, TableBody, Typography, Button } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import { Loading, Error } from 'react-admin';
export default function DetailCluster(props) {
    const dataProvider = useDataProvider();
    const [cluster, setCluster] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        dataProvider('GET_ONE', 'nodes', { id: props.location.state.record.id })


            .then(({ data }) => {
                setCluster(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, []);

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!cluster) return null;
    return (
        <div >
            <br />
            <TableContainer component={Paper}>
                <Typography gutterBottom variant="subtitle2" style={{ margin: 10 }}>
                    Cluster
                 </Typography>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell >ID</TableCell>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Level</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow >
                            <TableCell component="th" scope="row" >
                                {props.location.state.record.id}
                            </TableCell>
                            <TableCell component="th" scope="row" align="center" >
                                {props.location.state.record.name}
                            </TableCell>
                            <TableCell component="th" scope="row" align="center" >
                                {props.location.state.record.level}
                            </TableCell>

                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <br />
            <TableContainer component={Paper}>
                <Typography gutterBottom variant="subtitle2" style={{ margin: 10 }} >
                    Child
                 </Typography>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Level</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody align="center">
                        {cluster.children.map((cluster) => (
                            <TableRow >
                                <TableCell component="th" scope="row">
                                    {cluster.id}
                                </TableCell>
                                <TableCell component="th" scope="row" align="center" >
                                    {cluster.name}
                                </TableCell>
                                <TableCell component="th" scope="row" align="center" >
                                    {cluster.nodeLevel}
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Button style={{ margin: 10 }}
                variant="contained"
                color="primary"
                href="#/nodes">Back</Button>
        </div>

    )
}